// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TGMl","right":"styles_right__3MW0F"};